import { faFileXls } from '@fortawesome/pro-regular-svg-icons/faFileXls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { MprcIconButton } from 'components';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { MprcCardFilterBox } from 'components/filter/MprcCardFilterBox';
import { IconFilter } from 'components/icons';
import { HistoryOrderBy } from 'generated/CoreApi_v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdvancedFilter, IAdvFilterCommand } from 'views/general/AdvancedFilter';
import { FilterCmd } from 'views/general/AdvancedFilter/FilterCmd';
import { HistoryFilterOptions } from '.';

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    filterOptions: HistoryFilterOptions;
    totalRows: number;
    onFilterChange: (filter: Partial<HistoryFilterOptions>) => void;
    onExportXLS: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const Filter: React.FC<IProps> = ({ filterOptions, totalRows, onFilterChange, onExportXLS }) => {

    const { t } = useTranslation("lms");

    ///
    const dropdownOptions = (): IAdvFilterCommand[] => {
        var options: IAdvFilterCommand[] = [
            FilterCmd.Enroll.trainingMandatory(1),

            FilterCmd.Enroll.approved(2),
            FilterCmd.Enroll.reproved(2),
            FilterCmd.Enroll.canceledAndRevoked(2),
            FilterCmd.Enroll.rejected(2),

            FilterCmd.Enroll.certificationExpire(3),
            FilterCmd.Enroll.certificationExpiringIn30Days(3),
            FilterCmd.Enroll.certificationExpiringIn60Days(3),

            FilterCmd.Training.topic(4),
            FilterCmd.Enroll.historicPeriod(4),
        ];

        return options;
    };

    return <MprcCardFilterBox>
        <AdvancedFilter
            filter={filterOptions}
            leftDropdowns={[{
                filterCommands: dropdownOptions(),
                textOrIcon: <IconFilter />,
                title: t("shared:AdvFilter.Title")
            }]}
            leftDropdownAlign="end"
            orderMenuOptions={[
                { text: t("Student.History.OrderBy.MostRecentText"), value: HistoryOrderBy.MostRecent, group: 1 },
                { text: t("Student.History.OrderBy.TrainingNameText"), value: HistoryOrderBy.TrainingName, group: 1 },
                { text: t("Student.History.OrderBy.StatusText"), value: HistoryOrderBy.Status, group: 1 },
                { text: t("Student.History.OrderBy.ValidityDateText"), value: HistoryOrderBy.ValidityDate, group: 1 }
            ]}
            startComponent={
                <div>
                    <Typography variant="h3" noWrap component="div">
                        {t("Student.History.Title")}
                    </Typography>
                </div>
            }
            beforeLeftDropdown={
                [
                    <MprcIconButton disabled={totalRows == 0} onClick={() => onExportXLS()} title={t("Student.History.ExportXLSButtonText")}>
                        <FontAwesomeIcon icon={faFileXls} />
                    </MprcIconButton>
                ]
            }
            onFilterChange={(filter) => {
                onFilterChange({ ...filterOptions, ...filter });
            }}
            onError={error => MprcRequestSnackbarErrorReport(error)}
        />
    </MprcCardFilterBox>;
};
